import React from 'react';
import { Empty } from 'antd';

const NetworkStatsChart = ({ url }) => {
  return url ? (
    <iframe
      style={{ width: "100%", height: "600px", border: "none" }}
      src={url}
      title="Network Stats"
    />
  ) : (
    <Empty />
  );
};

export default NetworkStatsChart;